import { render, staticRenderFns } from "./BlockListKultuNautCustom.vue?vue&type=template&id=50874adc&"
import script from "./BlockListKultuNautCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListKultuNautCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports